import { VegaBox, VegaFlex, VegaSkeleton } from '@globalpayments/vega-react';

import styles from './index.module.css';

export type PageSkeletonVariant = 'detail' | 'form' | 'results' | 'table';

interface PageSkeletonProps {
  label: string;
  variant?: PageSkeletonVariant;
}

const imageSkeleton = (height: string, key: string) => (
  <VegaSkeleton animated corners="rounded-4" height={height} key={key} type="image" width="100%" />
);

/** Displays a Vega skeleton composition that approximates a page while its data loads. */
const PageSkeleton = ({ label, variant = 'detail' }: PageSkeletonProps) => {
  const skeletonContent = {
    detail: (
      <>
        <VegaSkeleton animated type="text" width="35%" />
        <VegaSkeleton animated type="paragraph" />
        <VegaSkeleton animated type="full-width-paragraph" />
        <VegaSkeleton animated type="table" />
      </>
    ),
    form: (
      <>
        <VegaSkeleton animated type="text" width="40%" />
        {imageSkeleton('48px', 'form-field')}
        {imageSkeleton('40px', 'form-action')}
      </>
    ),
    results: (
      <>
        <VegaSkeleton animated type="text" width="30%" />
        {imageSkeleton('96px', 'result-1')}
        {imageSkeleton('96px', 'result-2')}
        {imageSkeleton('96px', 'result-3')}
      </>
    ),
    table: (
      <>
        <VegaSkeleton animated type="text" width="30%" />
        <VegaSkeleton animated type="full-width-paragraph" />
        <VegaSkeleton animated type="table" />
      </>
    ),
  } satisfies Record<PageSkeletonVariant, React.ReactNode>;

  return (
    <div aria-label={label} className={`${styles.container} ${variant === 'form' ? styles.form : ''}`} role="status">
      <VegaBox width="100%">
        <VegaFlex direction="col" gap="size-24">
          {skeletonContent[variant]}
        </VegaFlex>
      </VegaBox>
    </div>
  );
};

export default PageSkeleton;